import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const fetchAllDoseLevelManagementService = async (
  pageNumber,
  pageSize,
  access_token,
  debouncedSearch = ""
) => {
  try {
    const filter = {
      mgDose: debouncedSearch,
      name: debouncedSearch,
    };
    return axios.get(
      `${api}/DosageLevel/GetDosageLevelPaginationData?pageNumber=${
        debouncedSearch !== "" ? 1 : pageNumber
      }&pageSize=${pageSize}&filter=${debouncedSearch}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const createDoseLevelService = async (access_token, data) => {
  try {
    return axios.post(`${api}/DosageLevel/Create`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const fetchDoseLevelByIdService = async (access_token, id) => {
  try {
    return axios.get(`${api}/DosageLevel/GetById?Id=${id}`, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const updateDoseLevelService = async (access_token, data, id) => {
  try {
    return axios.post(`${api}/DosageLevel/Update?Id=${id}`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};
